import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotificationsPage } from './pages/notifications.page';
import { TmNoteDetailsPage } from './pages/tm-notes-details/tm-note-details.page';
import { PATHS } from '../shared/constants/paths';

const routes: Routes = [
  {
    path: '',
    component: NotificationsPage,
  },
  {
    path: PATHS.NOTIFICATION_DETAILS,
    loadChildren: () =>
      import('./pages/notification-details/notification-details.module').then(
        m => m.NotificationDetailsPageModule,
      ),
  },
  {
    path: PATHS.NOTIFICATION_PREFERENCES,
    loadChildren: () =>
      import(
        './pages/preferences/dashboard/notification-preferences-dashboard.module'
      ).then(m => m.NotificationPreferencesDashboardPageModule),
  },
  {
    path: PATHS.NOTIFICATION_PREFERENCES_TYPE_OVERVIEW,
    loadChildren: () =>
      import(
        './pages/preferences/type-overview/notification-preferences-type-overview.module'
      ).then(m => m.NotificationPreferencesTypeOverviewPageModule),
  },
  {
    path: PATHS.NOTIFICATION_PREFERENCES_GROUP_CUSTOMERS,
    loadChildren: () =>
      import(
        './pages/preferences/group-customers/notification-preferences-group-customers.module'
      ).then(m => m.NotificationPreferencesGroupCustomersPageModule),
  },
  {
    path: PATHS.TM_NOTES,
    component: NotificationsPage,
  },
  {
    path: PATHS.NOTE_DETAILS,
    component: TmNoteDetailsPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationsPageRoutingModule {}
